import React, { useState } from 'react';
import OptionsAndOther from '../../choose_an_option';

export default function Prescription({ answers, onSubmit, onBack, gtm, showBack }) {
  return (
    <div className={`row activity-question`}>
      <div className='col-sm-2'></div>
      <div className='col-sm-8'>
        <OptionsAndOther
          answers={{ xcopriPrescription: answers.xcopriPrescription }}
          onSubmit={(newAnswers) => onSubmit({ ...answers, xcopriPrescription: newAnswers.xcopriPrescription })}
          onBack={onBack}
          title={`Are you or (or the patient) currently taking XCOPRI® (cenobamate tablets) CV?`}
          keyForAnswer={`xcopriPrescription`}
          choices={['Yes', 'No']}
          selectOne
          showOther={false}
          showBack={showBack}
        />
      </div>
      <div className='col-sm-2'></div>
    </div>
  );
}
